import Nullstack from 'nullstack';
export default function IconDisabled2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-disabled-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "17",
    cy: "6",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M9 11a5 5 0 1 0 3.95 7.95"
  }), "   ", Nullstack.element("path", {
    d: "M19 20l-4 -5h-4l3 -5l-4 -3l-4 1"
  }), " ");
}